import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  card: {
    width: '100%',
    maxWidth: '360px',
    padding: '1rem',
    textAlign: 'center'
  },
  container: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0,
    left: 0
  },
  logo: {
    height: 152,
    margin: '0 auto'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& .MuiTextField-root': {
      width: '100%',
      margin: '0.5rem'
    }
  },
  formSubmitButton: {
    width: '100%'
  }
}));